var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checkbox',_vm._g({attrs:{"indeterminate":_vm.indeterminate,"without-spacing":""},model:{value:(_vm.allSelected),callback:function ($$v) {_vm.allSelected=$$v},expression:"allSelected"}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }